/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */

import { ActionIconProps, UnstyledButton } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { forwardRef, PropsWithChildren } from "react";
import useGetProjetoById from "@/modules/projetos/hooks/useGetProjetoById";
import useUserStore from "@/modules/users/store";
import { captureException } from "@/services/log";

const POS_OLD = 1;
const POS_NEW = 3;

type CopyEmbaixadorUrlProperties = PropsWithChildren<
  ActionIconProps & {
    embaixador: TEmbaixadorPessoa;
  }
>;

export const CopyEmbaixadorUrlButton = forwardRef<HTMLButtonElement, CopyEmbaixadorUrlProperties>(
  ({ embaixador, children, ...properties }, reference) => {
    const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);
    const activeLicenciadaId = useUserStore((state) => state.activeLicenciadaId);
    const activeProjetoId = useUserStore((state) => state.activeProjeto);
    const { data: projeto } = useGetProjetoById(
      activeEmpresaId || "",
      activeProjetoId || "",
      activeLicenciadaId || undefined
    );

    const handleClick = async () => {
      if (!projeto) {
        showNotification({
          message: "É necessário selecionar um projeto para a URL do embaixador.",
          color: "red",
          autoClose: 2000
        });
        return;
      }

      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const referenceParts = projeto.refPath.split("/");
      const isLicenciada = referenceParts.includes("licenciadas");
      // Se for licenciada, projetoEmpresaId está no índice 3, e licenciadaId no índice 1.
      // Caso contrário, projetoEmpresaId está no índice 1; não existe licenciadaId.
      const projetoEmpresaId = referenceParts[isLicenciada ? POS_NEW : POS_OLD];
      const licenciadaId = isLicenciada ? referenceParts[1] : undefined;

      const autocadastroUrl = isLicenciada
        ? `${baseUrl}/auto-cadastro/${licenciadaId}/${projetoEmpresaId}/${projeto.id}/${embaixador.id}`
        : `${baseUrl}/auto-cadastro/${projetoEmpresaId}/${projeto.id}/${embaixador.id}`;

      try {
        await navigator.clipboard.writeText(autocadastroUrl);
        showNotification({
          title: "URL do embaixador copiada",
          message: autocadastroUrl,
          autoClose: 2500,
          color: "blue"
        });
      } catch (error) {
        const error_ = error as Error;
        captureException(error_, true);
        showNotification({
          message: "Não foi possível copiar a URL",
          autoClose: 1000,
          color: "red"
        });
      }
    };

    return (
      <UnstyledButton ref={reference} {...properties} onClick={handleClick}>
        {children}
      </UnstyledButton>
    );
  }
);

CopyEmbaixadorUrlButton.displayName = "CopyEmbaixadorUrlButton";
